import React from 'react'
import ReactDOM from 'react-dom';
import Rheostat from 'rheostat';
import ProductType from 'components/marketplace/productType';
import RangeSlider from 'components/marketplace/rangeSlider';
import RoadworthyType from 'components/marketplace/roadworthyType';
import FilterCheckboxOption from 'components/marketplace/filterCheckboxOption';


class SearchFilter extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    const classList = event.target.className;
    if (classList.indexOf("active") >= 0) {
      event.target.classList.remove("active")
    } else {
      event.target.classList.add("active")
    }
  }

  render() {
    const { selectedTender, tenders, handleCheckbox, handleRoadworthy, handleProductType, updateYearValue, yearLeftHandleValue, yearRightHandleValue, filterOptions, filterData, mileageLeftHandleValue, mileageRightHandleValue, onSliderDragEnd, updateMileageValue, selectedBodyTypes, selectedMakes, selectedModel, selectedLocation, selectedTransmission, selectedEngine, selectedFuel, selectedExteriorColor, selectedCondition, selectedProduct, selectedRoadworthy } = this.props;
    let fuelType = []
    let roadworthy = []
    let fuelTypeArray = []
    let roadworthyArray = []
    let mileageMin = 0
    let mileageMax = 0

    if (filterData.roadworthy != null) {
      roadworthy = filterData.roadworthy.map(function(x){
        if (x != null) { return x.charAt(0).toUpperCase() + x.substr(1) }
      })
      // Remove duplicate roadworthy after changing it to Uppercase ex) [yes, Yes] - [Yes, Yes]
      roadworthyArray = roadworthy.filter(function(item, position) { return roadworthy.indexOf(item) == position})
    }

    if (filterData.fuel_types != null) {
      fuelType = filterData.fuel_types.map(function(x){
        if (x != null) { return x.charAt(0).toUpperCase() + x.substr(1) }
      })
      // Remove duplicate fuel type after changing it to Uppercase ex) [petrol, Petrol] - [Petrol, Petrol]
      fuelTypeArray = fuelType.filter(function(item, position) { return fuelType.indexOf(item) == position})
    }

    if ((mileageLeftHandleValue && mileageRightHandleValue) != null) {
      mileageMin = mileageLeftHandleValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      mileageMax = mileageRightHandleValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    return (
      <div>
        <div className="search-option">
          <FilterCheckboxOption option={'selectedTender'} name={'Tender'} type={tenders} handleCheckbox={handleCheckbox} selectedValues={selectedTender}/>
        </div>

        <div className="search-option">
          <FilterCheckboxOption option={'selectedMakes'} name={'Make'} type={filterData.makes} handleCheckbox={handleCheckbox} selectedValues={selectedMakes}/>
        </div>

        <div className="search-option">
          <FilterCheckboxOption option={'selectedModel'} name={'Model'} type={filterData.models} handleCheckbox={handleCheckbox} selectedValues={selectedModel}/>
        </div>

        <div className="search-option">
          <RangeSlider name={"Year"} min={filterOptions.min_year} max={filterOptions.max_year} leftHandleValue={yearLeftHandleValue} rightHandleValue={yearRightHandleValue} onSliderDragEnd={onSliderDragEnd} onValuesUpdated={updateYearValue}>
            <span>{yearLeftHandleValue} - {yearRightHandleValue}</span>
          </RangeSlider>
        </div>

        <div className="search-option">
          <RangeSlider name={"Kilometer"} min={filterOptions.min_mileage} max={filterOptions.max_mileage} leftHandleValue={mileageLeftHandleValue} rightHandleValue={mileageRightHandleValue} onSliderDragEnd={onSliderDragEnd} onValuesUpdated={updateMileageValue}>
            <span>{mileageMin}km - {mileageMax}km</span>
          </RangeSlider>
        </div>

        <div className="search-option">
          <FilterCheckboxOption option={'selectedBodyTypes'} name={'Body Type'} type={filterData.body_types} handleCheckbox={handleCheckbox} selectedValues={selectedBodyTypes}/>
        </div>

        <div className="search-option">
          <FilterCheckboxOption option={'selectedLocation'} name={'Location'} type={filterData.location} handleCheckbox={handleCheckbox} selectedValues={selectedLocation}/>
        </div>

        <div className="search-option">
          <FilterCheckboxOption option={'selectedProduct'} name={'Product Group'} type={filterData.product_types} handleCheckbox={handleCheckbox} selectedValues={selectedProduct}/>
        </div>

        <div className="search-option">
          <h5 className="cars-search-option roadworthy-option active" data-toggle="collapse" data-target=".roadworthy" onClick={this.handleClick}>Roadworthy</h5>
          <div className="cars-collapse roadworthy collapse in">
            <RoadworthyType roadworthyType={roadworthyArray} handleChange={handleRoadworthy} selectedValue={selectedRoadworthy}/>
          </div>
        </div>

        <div className="search-option">
          <FilterCheckboxOption option={'selectedTransmission'} name={'Transmission'} type={filterData.transmission} handleCheckbox={handleCheckbox} selectedValues={selectedTransmission}/>
        </div>

        <div className="search-option">
          <FilterCheckboxOption option={'selectedEngine'} name={'Engine Capacity'} type={filterData.engine_capacity} handleCheckbox={handleCheckbox} selectedValues={selectedEngine}/>
        </div>

        <div className="search-option">
          <FilterCheckboxOption option={'selectedFuel'} name={'Fuel Type'} type={fuelTypeArray} handleCheckbox={handleCheckbox} selectedValues={selectedFuel}/>
        </div>

        <div className="search-option">
          <FilterCheckboxOption option={'selectedExteriorColor'} name={'Exterior Color'} type={filterData.exterior_color} handleCheckbox={handleCheckbox} selectedValues={selectedExteriorColor}/>
        </div>
      </div>
    )
  }
};

export default SearchFilter;
